import React from 'react';
import '../../styles/content-grid.scss';
import ReelPlayer from './ReelPlayer/ReelPlayer';

const ContentReelCard = ({ content, style, playerStyle }) => {
  return <ReelPlayer content={content} style={playerStyle} />;
};

export default ContentReelCard;
